import { DeliveryAddressViewObject } from '@/types/apiServerContract';
import { ExtendedDeliveryAddressViewObject } from '@/project/app/client-pages/checkout/types';

const localPrefix = 'local-';
let deliveryAddresses: DeliveryAddressViewObject[] = [];

function getDeliveryAddresses(): DeliveryAddressViewObject[] {
    return deliveryAddresses;
}

function genLocalWebId(): string {
    return `${localPrefix}${Math.random()}`;
}

function isLocalWebId(webId: string): boolean {
    return webId != null && webId.startsWith(localPrefix);
}

function setOriginalDeliveryAddresses(addresses: DeliveryAddressViewObject[]) {
    deliveryAddresses = [...addresses];
}

function applyAddress(addr: ExtendedDeliveryAddressViewObject) {
    const findPredicate = createFindPredicate(addr);
    const existing = deliveryAddresses.find(findPredicate);
    if (existing) {
        // Remove old to update
        deliveryAddresses = deliveryAddresses.filter(addrInList => !findPredicate(addrInList));
    }
    // Check for update on isDefault
    if (addr.isDefault) {
        // isDefault set - clear for everyone
        deliveryAddresses.forEach(a => a.isDefault = false);
    }
    deliveryAddresses.push(addr);

    function createFindPredicate(addr: ExtendedDeliveryAddressViewObject) {
        // If addr has a temporary id - use that to look up - else use webid
        return (other: ExtendedDeliveryAddressViewObject) => {
            return addr.temporaryId ? addr.temporaryId === other.temporaryId : addr.webId === other.webId;
        };
    }
}

export default {
    genLocalWebId,
    isLocalWebId,
    applyAddress,
    setOriginalDeliveryAddresses,
    getDeliveryAddresses
};
